import TextField from "@mui/material/TextField";
import { ReactComponent as SearchSmIcon } from "components/Icons/search-sm.svg";
import { useMessage } from "hooks/intl";
import { useStyles } from "./StoreSelect.styles";

interface Props {
  handleAdditionalMenuOpen: () => void;
  setNameSearch: (phrase: string) => void;
  nameSearch: string;
}

export const StoreSearch = ({
  handleAdditionalMenuOpen,
  setNameSearch,
  nameSearch,
}: Props) => {
  const classes = useStyles({});
  const { message } = useMessage();

  const stopPropagation = (event: {
    key: any;
    stopPropagation: () => void;
  }) => {
    switch (event.key) {
      case "ArrowDown":
      case "ArrowUp":
      case "End":
      case "Escape":
      case "Home":
      case "Tab":
        break;
      default:
        event.stopPropagation();
    }
  };

  return (
    <TextField
      variant="standard"
      className={classes.search}
      InputProps={{
        disableUnderline: true,
        startAdornment: <SearchSmIcon className={classes.searchIcon} />,
      }}
      value={nameSearch}
      onChange={(e) => setNameSearch(e.target.value)}
      onKeyDown={stopPropagation}
      onClick={handleAdditionalMenuOpen}
      placeholder={message({ id: "searchForTenants" })}
      inputProps={{
        autoComplete: "off",
        "data-test-id": "tenant-search",
      }}
    />
  );
};
